import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import React, { useState } from 'react'

import TeamMemberDetailsModal from 'Components/Blocks/Modals/TeamMemberDetails'
import { Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import { AboutUsPageQuery } from 'GraphQL/DatoCMS/TypedDocuments'

import { useResponsiveLayout } from 'Hooks'

import Button from './Button'
import Card from './Card'
import { Container, Mask } from './styles'

type Props = {
  data?: AboutUsPageQuery
}

function TeamMembersGallery({ data }: Props) {
  const { isMobile, isDesktop } = useResponsiveLayout()

  const [selectedTeamMember, setSelectedTeamMember] = useState<any>(undefined)

  if (!data) return null

  return (
    <Container>
      <Swiper
        centeredSlides
        grabCursor
        loop
        modules={[Pagination]}
        pagination={{ clickable: true }}
        slidesPerView={isDesktop ? 3 : 1}
        spaceBetween={24}
      >
        {!isMobile && (
          <>
            <Mask />
            <Button />
            <Button isNext />
          </>
        )}

        {data?.aboutUsPage?.teamMembers.map(item => (
          <SwiperSlide key={item.id}>
            <Card data={item} onAction={() => setSelectedTeamMember(item)} />
          </SwiperSlide>
        ))}
      </Swiper>

      <TeamMemberDetailsModal
        data={selectedTeamMember}
        isOpened={!!selectedTeamMember}
        onClose={() => setSelectedTeamMember(undefined)}
      />
    </Container>
  )
}

export default TeamMembersGallery
